import Link from 'next/link';

type Props = {
  site: any;
  categories: any;
};

export default function CategoriesList({ site, categories }: Props) {
  if (!site || !categories) {
    return <></>;
  }

  return (
    <section className="centered categories-list-section">
      <div className="section-inner">
        <div className="categories-nav">
          <div className="categories-nav-inner">
            <p className="categories-nav-title">{site.tpl_search_nav_title}</p>
            <ul>
              {categories
                .filter((category) => category.children && category.children.length > 0)
                .map((category) => {
                  let id = category.title
                    .trim()
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/à|â/g, 'a')
                    .replace(/é|è|ê/g, 'e')
                    .replace(/ô/g, 'o')
                    .replace(/ù/g, 'u');
                  return (
                    <li key={category.title}>
                      <Link href={`#${id}`} className={id}>
                        <span className="text">{category.title}</span>
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>

        {categories?.length > 0 && (
          <div className="categories-list">
            {categories
              .filter((category) => category.children && category.children.length > 0)
              .map((category) => {
                let id = category.title
                  .trim()
                  .toLowerCase()
                  .replace(/ /g, '-')
                  .replace(/à|â/g, 'a')
                  .replace(/é|è|ê/g, 'e')
                  .replace(/ô/g, 'o')
                  .replace(/ù/g, 'u');
                return (
                  <div className="category" key={category.title} id={id}>
                    <div className="category-header">
                      <div className="category-title">
                        {category.image && category.image.url && (
                          <img
                            src={category.image.url}
                            alt={category.title}
                            className="icon"
                            width="44"
                            height="44"
                            loading="lazy"
                          />
                        )}
                        <span className="text">{category.title}</span>
                      </div>
                      <div
                        className="category-description"
                        dangerouslySetInnerHTML={{ __html: category.description }}
                      ></div>
                    </div>
                    <div className="category-children">
                      <ul>
                        {category.children.map((child) => {
                          if (child.url) {
                            return (
                              <li key={child.title}>
                                <Link href={child.url}>
                                  <span className="child-title">{child.title}</span>
                                </Link>
                              </li>
                            );
                          }
                        })}
                      </ul>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </section>
  );
}
